




























































import {Vue, Component} from "vue-property-decorator";
import {MarkaVozila, ModelVozila} from "../../../services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

declare const $: any;

@Component({})
export default class MarkeVozila extends mixins(ComponentBaseMixin) {
    markaVozila = new MarkaVozila();
    modelVozila = new ModelVozila();

    columns = [];
    dataSource = [];
    options = {
        pagination: true,
        search: true,
        detailView: true,
        detailFormatter: this.renderDetails,
        onClickRow: marka => this.edit(marka)
    };

    dialogVisible = false;
    selectedDetailsTableClass = '';

    async created() {
        this.columns = [{field: "naziv", title: this.$i18n.t("naziv")}];
        this.dataSource = await this.loadData(() => dataProxy.vratiMarkeVozila())();
    }

    novaMarka() {
        this.markaVozila = new MarkaVozila();
        (<HTMLElement>this.$refs.nova).focus();
    }

    private edit(marka) {
        this.markaVozila = marka;
    }

    private renderDetails(ix, marka: MarkaVozila, element) {
        const detailsTableId = `detailsTable_${ix}`;
        const $detailsTable = $(`<table class='${detailsTableId}'></table>`).bootstrapTable({
            columns: [
                {field: "naziv", title: this.$i18n.t("modelVozila")},
                {
                    field: "id",
                    width: 30,
                    formatter: (id) =>
                        `<button class="btn btn-icon waves-effect waves-light btn-sm btn-light btn-delete-subgroup" data-id="${id}" data-table="${detailsTableId}"><i class="dripicons-trash"></i></button>`,
                    title: `<button class="btn btn-icon waves-effect waves-light btn-light btn-sm btn-add-subgroup" data-table="detailsTable_${ix}"><i class="fa fa-plus"></i></button>`
                }
            ],
            data: marka.modeliVozila,
            onPostBody: () => {
                this.$nextTick(() => {
                    $(`.${detailsTableId} .btn-delete-subgroup`).on('click', (e) => {
                        const id = $(e.currentTarget).data('id');
                        const tableClass = $(e.currentTarget).data('table');
                        this.obrisiModel(id, tableClass);
                    });
                    $(`.${detailsTableId} .btn-add-subgroup`).on('click', (e) => {
                        this.modelVozila = ModelVozila.fromJS({markaVozilaId: marka.id});
                        this.selectedDetailsTableClass = $(e.currentTarget).data('table');
                        this.dialogVisible = true;
                    })
                })
            }
        });
        $detailsTable.appendTo(element);
    }

    async sacuvajMarkuVozila() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.markaVozila.id = await this.saveData(() =>
                dataProxy.sacuvajMarkuVozila(this.markaVozila)
            )();
            this.dataSource = await this.loadData(() => dataProxy.vratiMarkeVozila())();
        }
    }

    async obrisiMarkuVozila() {
        const da = await this.confirmationNeeded(
            "da li zelite da obrisete marku vozila"
        );
        if (da) {
            this.dataSource = await this.deleteData(() =>
                dataProxy.obrisiMarkuVozila(this.markaVozila.id)
            )();
            this.novaMarka();
        }
    }

    async dodajModel() {
        const isValid = await (<any>this.$refs.observer).validate();
        if (isValid) {
            this.dialogVisible = false;
            const model = await this.saveData(() => dataProxy.sacuvajModelVozila(this.modelVozila))();
            const table = $("." + this.selectedDetailsTableClass);
            table.bootstrapTable('load', model);
        }
    }

    private async obrisiModel(id, tableClass: string) {
        const da = await this.confirmationNeeded('da li zelite da obrisete model vozila');
        if (da) {
            const modeli = await this.deleteData(() => dataProxy.obrisiModelVozila(id))();
            const table = $("." + tableClass);
            table.bootstrapTable('load', modeli);
        }
    }

    fokusirajNazivModela() {
        (<HTMLElement>this.$refs.nazivModela).focus();
    }
}
